import React, { useEffect, useState } from 'react';
import { withRouter, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import { Divider, Table, Tooltip } from 'antd';
import { v4 as uuidv4 } from 'uuid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAnglesRight, faDownload } from '@fortawesome/free-solid-svg-icons';
import AnalyticsActions from '@Actions/application/analyticsActions';
import H3Text from '@Uilib/h3Text';
import { toISTDate } from '@Apis/constants';
import Helpers from '@Apis/helpers';
import PRZText from '../../Common/UI/PRZText';
import useCheckPortrait from '../../../hooks/useCheckPortrait';
import './style.scss';

function BulkUploadsList({
  bulkUploads,
  getBulkUploads,
  getBulkUploadsLoading,
  history,
}) {
  
  const [limit, setLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

  const location = useLocation();

  const pushParamsToUrl = (page, pgSize) => {
    const params = new URLSearchParams(location.search);
    if (page) {
      params.set('page', page);
    }
    if (pgSize) {
      params.set('limit', pgSize);
    }
    history.push(`?${params.toString()}`);
  };

  useEffect(() => {
    pushParamsToUrl(currentPage, limit);
    getBulkUploads({
      page: currentPage,
      limit,
    }, () => {
    });
  }, [currentPage, limit]);

  const {
    isMobile, isPortrait, isMobileAndPortrait, isMobileOrPortrait,
  } = useCheckPortrait();

  const getColumns = () => {
    const bulkUploadColumns = [
      {
        title: '',
        render: (record) => (
          <div className="mobile-list__card">
            <div className="mobile-list__card_header">
              <div className="mobile-list__card_header-left">
                <PRZText
                  text={record?.event_type?.replaceAll('_', ' ')?.toProperCase()}
                  className="mobile-list__card_item-number"
                />
              </div>
              <div className="mobile-list__card_header-right">
                <PRZText
                  text={record?.status}
                  style={{ backgroundColor: Helpers.getStatusColor(record?.status).color }}
                  className="mobile-list__card__status"
                />
              </div>
            </div>
            <div className="mobile-list__card_body">
              <div
                className="mobile-list__card_body-left"
                style={{
                  width: '100%',
                }}
              >
                <PRZText
                  text={(
                    <div style={{
                      display: 'flex', gap: '2px', alignItems: 'center', justifyContent: 'space-between',
                    }}
                    >
                      <span>Total Records: </span>
                      <span style={{
                        display: 'flex', gap: '2px', alignItems: 'center',
                      }}
                      >
                        {record?.response?.total_records || '-'}
                        {Number(record?.response?.total_records) > 0
                          ? (
                            <a href={record?.response?.original_file_url} target="_blank" rel="noreferrer">
                              <H3Text
                                text={(<FontAwesomeIcon icon={faDownload} />)}
                                className="bulk-import__download"
                              />
                            </a>
                          ) : ''}
                      </span>

                    </div>
                  )}
                  className="mobile-list__card_item-details"
                  style={{
                    maxWidth: '100%',
                  }}
                />

                <PRZText
                  text={(
                    <div style={{
                      display: 'flex', gap: '2px', alignItems: 'center', justifyContent: 'space-between'
                    }}
                    >
                      <span>Record Created: </span>
                      <span style={{
                        display: 'flex', gap: '2px', alignItems: 'center',
                      }}
                      >
                        <span>{record?.response?.records_created || '-'}</span>
                        {Number(record?.response?.records_created) > 0
                          ? (
                            <a href={record?.response?.records_created_file} target="_blank" rel="noreferrer">
                              <H3Text
                                text={(<FontAwesomeIcon icon={faDownload} />)}
                                className="bulk-import__download"
                              />
                            </a>
                          ) : ''}
                      </span>
                    </div>
                  )}
                  className="mobile-list__card_item-details"
                  style={{
                    maxWidth: '100%',
                  }}
                />

                <PRZText
                  text={(
                    <div style={{
                      display: 'flex', gap: '2px', alignItems: 'center', justifyContent: 'space-between',
                    }}
                    >
                      <span>Record Failed: </span>
                      <span style={{
                        display: 'flex', gap: '2px', alignItems: 'center',
                      }}
                      >
                        <span>{record?.response?.records_errored || '-'}</span>
                        {Number(record?.response?.records_errored) > 0
                          ? (
                            <a href={record?.response?.records_errored_file} target="_blank" rel="noreferrer">
                              <H3Text
                                text={(<FontAwesomeIcon icon={faDownload} />)}
                                className="bulk-import__download"
                              />
                            </a>
                          ) : ''}
                      </span>
                    </div>
                  )}
                  className="mobile-list__card_item-details"
                  style={{
                    maxWidth: '100%',
                  }}
                />

                <Tooltip
                  title={(
                    <PRZText
                      className="mobile-list__card_item__tooltip_text-color mobile-list__card_item__category__tooltip"
                      text={`${toISTDate(record?.created_at).format('DD/MM/YYYY')} ( ${record?.created_by_info ? `${record?.created_by_info.first_name} ${record?.created_by_info.last_name}` : ''})`}
                    />
                  )}
                  color="white"
                >
                  <PRZText text={`Created By ${record?.created_by_info ? `${record?.created_by_info.first_name} ${record?.created_by_info.last_name}` : ''} on ${toISTDate(record?.created_at).format('DD/MM/YYYY')}`} className="mobile-list__card_item-details created_by_info" />
                </Tooltip>

              </div>
            </div>
          </div>
        ),
        // responsive: ['xs'],
        hidden: !isMobile,
      },
      {
        title: 'IMPORT LABEL',
        fixed: 'left',
        render: (record) => (
          <H3Text text={record?.event_type?.replaceAll('_', ' ')?.toProperCase()} />
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
      },
      {
        title: 'TOTAL RECORDS',
        key: 'action',
        render: (record) => (
          <div className="flex-display flex-align-c">
            {record?.response?.total_records || '-'}
            {Number(record?.response?.total_records) > 0
              ? (
                <a href={record?.response?.original_file_url} target="_blank" rel="noreferrer">
                  <H3Text
                    text={(<FontAwesomeIcon icon={faDownload} />)}
                    className="bulk-import__download"
                  />
                </a>
              ) : ''}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
      },
      {
        title: 'RECORDS CREATED',
        render: (record) => (
          <div className="flex-display flex-align-c">
            {record?.response?.records_created || '-'}
            {Number(record?.response?.records_created) > 0
              ? (
                <a href={record?.response?.records_created_file} target="_blank" rel="noreferrer">
                  <H3Text
                    text={(<FontAwesomeIcon icon={faDownload} />)}
                    className="bulk-import__download"
                  />
                </a>
              ) : ''}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
      },
      {
        title: 'RECORDS FAILED ',
        key: 'action',
        render: (record) => (
          <div className="flex-display flex-align-c">
            {record?.response?.records_errored || '-'}
            {Number(record?.response?.records_errored) > 0
              ? (
                <a href={record?.response?.records_errored_file} target="_blank" rel="noreferrer">
                  <H3Text
                    text={(<FontAwesomeIcon icon={faDownload} />)}
                    className="bulk-import__download"
                  />
                </a>
              ) : ''}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
      },
      {
        title: 'STATUS',
        render: (record) => (
          <div>
            <div className="status-tag" style={{ backgroundColor: Helpers.getStatusColor(record?.status).color }}>
              {record?.status}
            </div>
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
      },
      {
        title: 'CREATED BY',
        render: (record) => (
          <div>
            <div className="column-date">
              {toISTDate(record?.created_at).format('DD/MM/YYYY')}
            </div>
            <H3Text text={(record?.created_by_info ? `${record?.created_by_info.first_name} ${record?.created_by_info.last_name}` : '')} className="table-subscript" />
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
      },

    ];

    return bulkUploadColumns.filter((item) => !item.hidden);
  };

  const getDataSource = () => {
    const tempData = [];
    for (let i = 0; i < bulkUploads?.tasks?.length; i++) {
      tempData.push({
        ...bulkUploads?.tasks?.[i],
        key: uuidv4(),
      });
    }
    return tempData;
  };

  return (
    <div className="doc-list__wrapper doc-list__tab-content">
      <div className="ant-row">
        <div className="ant-col-xs-24">
          <div className="doc-list__table-wrapper">
            <Table
              title={() => (
                <div className="doc-list__table-header">
                  <div className="doc-list__table-header__left">
                    Past Bulk Actions
                  </div>
                </div>
              )}
              loading={getBulkUploadsLoading}
              bordered
              showHeader
              size="small"
              pagination={
                {
                  defaultCurrent: currentPage,
                  current: currentPage,
                  total: bulkUploads ? bulkUploads?.count : 0,
                  pageSize: limit,
                  onChange: (currPage, pgSize) => {
                    setCurrentPage(currPage);
                    setLimit(pgSize);
                  },
                  position: ['bottomLeft'],
                  showTotal: (tot, range) => `${range[0]}-${range[1]} of ${tot} items`,
                  showSizeChanger: true,
                  pageSizeOptions: [10, 25, 50, 100],
                }
              }
              columns={getColumns()}
              dataSource={getDataSource()}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = ({ AnalyticsReducers }) => ({
  getBulkUploadsLoading: AnalyticsReducers.getBulkUploadsLoading,
  bulkUploads: AnalyticsReducers.bulkUploads,
});

const mapDispatchToProps = (dispatch) => ({
  getBulkUploads: (payload, callback) => dispatch(AnalyticsActions.getBulkUploads(payload, callback)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(BulkUploadsList));
